
import styles from "../HealthChat.module.css";
import { HeartIcon, SummaryIcon, MessageIcon, WalkIcon, SleepIcon, NutritionIcon, StressIcon } from "../icons";

const LIFESTYLE_ICONS = [
  <WalkIcon size={14} />,
  <SleepIcon size={14} />,
  <NutritionIcon size={14} />,
  <StressIcon size={14} />,
  <WalkIcon size={14} />,
];

export default function SummaryScreen({ t, summary, selectedSymptoms = [], onBack }) {
  // Use live selectedSymptoms from flow, fallback to summary payload or defaults
  const symptoms = selectedSymptoms.length > 0
    ? selectedSymptoms
    : (summary?.symptoms || t.defaultSymptoms);

  const bodyText = summary?.bodyText || t.defaultBody;
  const lifestyleTexts = summary?.lifestyle || t.defaultLifestyle;

  return (
    <div className={styles.summaryScreen}>
      {/* Header */}
      <div className={styles.summaryHeader}>
        <div className={styles.summaryHeaderIcon}>
          <HeartIcon size={22} color="#fff" />
        </div>
        <div>
          <div className={styles.summaryTitle}>{t.title}</div>
          <div className={styles.summarySub}>{t.subtitle}</div>
        </div>
      </div>

      {/* Symptoms */}
      <div className={styles.summarySection}>
        <div className={styles.sectionLabel}>{t.symptomsLabel}</div>
        <div className={styles.tagRow}>
          {symptoms.map((s, i) => (
            <span key={i} className={styles.tag}>{s}</span>
          ))}
        </div>
      </div>

      {/* Commonly Associated Changes */}
      <div className={styles.summarySection}>
        <div className={styles.sectionLabel}>{t.changesLabel}</div>
        <p className={styles.summaryText}>{bodyText}</p>
      </div>

      {/* Lifestyle Guidance */}
      <div className={styles.summarySection}>
        <div className={styles.sectionLabel}>{t.lifestyleLabel}</div>
        <div className={styles.lifestyleList}>
          {lifestyleTexts.map((text, i) => (
            <div key={i} className={styles.lifestyleRow}>
              <span className={styles.lifestyleRowIcon}>
                {LIFESTYLE_ICONS[i % LIFESTYLE_ICONS.length]}
              </span>
              <span>{text}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Medical Consultation */}
      <div className={styles.summarySection}>
        <div className={styles.sectionLabel}>{t.consultLabel}</div>
        <p className={styles.summaryText}>{bodyText}</p>
      </div>

      <button className={styles.primaryBtn} onClick={onBack}>
        {t.continuBtn}
      </button>

      <p className={styles.disclaimer}>{t.disclaimer}</p>
    </div>
  );
}
